export const receiveBackInStockVariants = (
  state,
  { payload: { variantIds } }
) => {
  const newState = {
    ...state,
    backInStockVariants: variantIds
  };

  return newState;
};
